import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { SafeStylePipe } from './pipes/safe-style.pipe';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { TrustResourceUrlPipe } from './pipes/trust-resource-url.pipe';

/** DomSanitizerModule */
@NgModule({
  imports: [CommonModule],
  declarations: [
    SafeHtmlPipe,
    SafeUrlPipe,
    SafeStylePipe,
    TrustResourceUrlPipe,
  ],
  exports: [SafeHtmlPipe, SafeUrlPipe, SafeStylePipe, TrustResourceUrlPipe],
})
export class DomSanitizerModule {}
